module.exports = __webpack_public_path__ + "img/SKMP_SGR.5b69cea2.jpg";